import { screenSmMin, screenXsMax, spacer4, spacer48 } from '@spotify-internal/encore-foundation';
import styled from 'styled-components';
import { defaultColorSet } from "../../styles";
import { ListItem } from "../ListItem";
export var Item = styled(ListItem).withConfig({
  displayName: "Item",
  componentId: "sc-16ne99o-0"
})(["min-inline-size:0;color:var(--text-base,", ");@media (max-width:", "){padding-block-end:", ";padding-block-start:", ";&:last-child{padding-block-end:0;}}@media (min-width:", "){padding-inline-end:", ";&:last-child{flex-grow:1;padding-inline-end:0;}}"], defaultColorSet.text.base, screenXsMax, spacer4, spacer4, screenSmMin, spacer48);
export default Item;